<div class="modal-header">
	<h4 class="modal-title fw-bold">
		<span jhiTranslate="germplasm-list.import.multi.matches.header"></span>
	</h4>
	<button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"
			(click)="dismiss()">
	</button>
</div>
<div class="modal-body">
	<div>
		<div class="row mb-sm-3">
			<div class="col">
				<span jhiTranslate="germplasm-list.import.manual.matches.description"></span>
			</div>
		</div>
		<div class="row">
			<div class="col">
				<div class="table-responsive">
					<table class="table table-striped table-bordered table-curved">
						<thead>
                        <tr>
						<th>#</th>
						<th>{{'germplasm-list.import.multi.matches.headers.gid' | translate}}</th>
						<th>{{'germplasm-list.import.multi.matches.headers.guid' | translate}}</th>
						<th>{{'germplasm-list.import.multi.matches.headers.designation' | translate}}</th>

						<th>{{'germplasm-list.import.multi.matches.headers.mapped.gid' | translate}}</th>
						<th>{{'germplasm-list.import.multi.matches.headers.mapped.designation' | translate}}</th>

						<th>{{'germplasm-list.import.multi.matches.headers.status' | translate}}</th>
						<th>{{'germplasm-list.import.multi.matches.headers.action' | translate}}</th>
                        </tr>
						</thead>
						<tbody>
						<tr>
						<tr *ngFor="let row of rows | slice: (page-1) * pageSize : page * pageSize">
							<td>{{row[HEADERS.ROW_NUMBER]}}</td>
							<td>{{row[HEADERS.GID]}}</td>
							<td>{{row[HEADERS.GUID]}}</td>
							<td>{{row[HEADERS.DESIGNATION]}}</td>
							<td>
								<a class="link" class="link" *ngIf="row['MAPPED GID']" [href]="germplasmDetailsUrlService.getUrl(row['MAPPED GID'])" target="_blank">{{row['MAPPED GID']}}</a>
							</td>
							<td>
								<a *ngIf="row['MAPPED GID']" [href]="germplasmDetailsUrlService.getUrl(row['MAPPED GID'])" target="_blank">{{row['MAPPED DESIGNATION']}}</a>
							</td>
							<td>
								<span class="fa fa-check-circle text-success" *ngIf="validMapped(row)"></span>
								<span class="fa fa-ban text-danger" *ngIf="!validMapped(row)"></span>
							</td>
							<td>
                                <button class="btn btn-outline-info btn-sm" (click)="selectGermplasm(row)"><i class="fa fa-link"></i></button>
							</td>
						</tr>
						</tbody>
					</table>
				</div>
				<div class="row">
					<div class="col">
						<div class="pagination-container">
							<div class="pagination-box pagination-box-left">
								<div>
									<jhi-item-count [page]="page" [total]="rows.length" [itemsPerPage]="pageSize"></jhi-item-count>
								</div>
							</div>
							<div class="pagination-box">
								<ngb-pagination [collectionSize]="rows.length" [(page)]="page" [pageSize]="pageSize" [disabled]="isLoading"
												[maxSize]="5" [rotate]="true" [boundaryLinks]="true"></ngb-pagination>
							</div>
							<div class="pagination-box pagination-box-right">
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<div class="modal-footer">
	<button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="back()">
		<span jhiTranslate="back"></span>
	</button>
	<button (click)="next()" class="btn btn-primary">
		<span class="fa fa-save"></span>&nbsp;<span jhiTranslate="next"></span>
	</button>
</div>
<ng-template #throbber>
	<span class="throbber"></span>
</ng-template>
